import loadable from '@loadable/component';
import {
    Unauthorized,
    AccessDenied,
    KbaUnavailable,
    AccessLocked,
    SessionExpired,
    NotFound
} from '@components/shared/ErrorPages';
import {
    TRANSACTION_PATH,
    CEREMONY_PATH,
    AUTHENTICATION_PATH,
    USER_AUTH_PATH,
    RECIPIENT_AUTH_PATH,
    SENDER_AUTH_PATH,
    UNAUTHORIZED_PATH,
    ACCESS_DENIED_PATH,
    KBA_UNAVAILABLE_PATH,
    ACCESS_LOCKED_PATH,
    SESSION_EXPIRED_PATH,
    NOT_FOUND_PATH
} from '@constants';
import SigningCeremony from '@components/SignerUi/SigningCeremony/SigningCeremony';
import NotFoundRedirect from '@components/SignerUi/SigningCeremony/NotFoundRedirect';
import AuthenticationPage from '@components/AuthenticationPage/AuthenticationPage';
import signerUiSsrFetch from '@components/SignerUi/ssrFetch';
import {getSignerRouteConfig} from './routeConfigs';
import ceremonyRoutes from './ceremonyRoutes';

export const signerUiRoutes = [
    {
        path: `${TRANSACTION_PATH}/:packageId${CEREMONY_PATH}`,
        component: SigningCeremony,
        end: false,
        fetchData: signerUiSsrFetch,
        childrenRoutes: [
            {
                index: true,
                component: loadable(
                    () => import(
                        /* webpackChunkName: "signer-ui-ceremony-redirect" */
                        '../components/SignerUi/SigningCeremony/CeremonyRedirect'
                    )
                )
            },
            ...ceremonyRoutes.map((route) => ({
                path: route.path,
                component: route.component,
                end: route.exact,
                isLeftMenuVisible: route.isLeftMenuVisible
            })),
            {
                path: '*',
                component: NotFoundRedirect
            }
        ],
        ...getSignerRouteConfig(`${TRANSACTION_PATH}/:packageId${CEREMONY_PATH}`)
    },
    {
        path: `${USER_AUTH_PATH}/*`,
        component: AuthenticationPage,
        end: true,
        fetchData: signerUiSsrFetch,
        ...getSignerRouteConfig(`${USER_AUTH_PATH}/*`)
    },
    {
        path: `${RECIPIENT_AUTH_PATH}/*`,
        component: AuthenticationPage,
        end: false,
        fetchData: signerUiSsrFetch,
        ...getSignerRouteConfig(`${RECIPIENT_AUTH_PATH}/*`)
    },
    {
        path: `${AUTHENTICATION_PATH}/*`,
        component: AuthenticationPage,
        end: false,
        fetchData: signerUiSsrFetch,
        ...getSignerRouteConfig(`${AUTHENTICATION_PATH}/*`)
    },
    {
        path: `${UNAUTHORIZED_PATH}/recipient`,
        component: Unauthorized,
        end: true,
        ...getSignerRouteConfig(`${UNAUTHORIZED_PATH}/recipient`)
    },
    {
        path: `${ACCESS_DENIED_PATH}/recipient`,
        component: AccessDenied,
        end: true,
        ...getSignerRouteConfig(`${ACCESS_DENIED_PATH}/recipient`)
    },
    {
        path: `${KBA_UNAVAILABLE_PATH}/recipient`,
        component: KbaUnavailable,
        end: true,
        ...getSignerRouteConfig(`${KBA_UNAVAILABLE_PATH}/recipient`)
    },
    {
        path: `${ACCESS_LOCKED_PATH}/recipient`,
        component: AccessLocked,
        end: true,
        ...getSignerRouteConfig(`${ACCESS_LOCKED_PATH}/recipient`)
    },
    {
        path: `${SESSION_EXPIRED_PATH}/recipient`,
        component: SessionExpired,
        end: true,
        ...getSignerRouteConfig(`${SESSION_EXPIRED_PATH}/recipient`)
    },
    {
        path: `${NOT_FOUND_PATH}/recipient`,
        component: NotFound,
        end: true,
        ...getSignerRouteConfig(`${NOT_FOUND_PATH}/recipient`)
    },
    {
        path: SENDER_AUTH_PATH,
        component: AuthenticationPage,
        end: true,
        fetchData: signerUiSsrFetch,
        ...getSignerRouteConfig(SENDER_AUTH_PATH)
    }
];

export default signerUiRoutes;
